import { API } from '..';

// Phân quyền admin (RBAC) — chỉ tài khoản có quyền Role.Manage (SuperAdmin) gọi được.
const BASE = '/v1/identity-service/accounts/cms/admin';

export interface AccountRolesInfo {
  email: string;
  userName: string;
  roles: string[];
  assignableRoles: string[];
}

export interface AdminRow {
  email: string;
  userName: string;
  roles: string[];
}

export const findAccountForRoles = (email: string) =>
  API.post<AccountRolesInfo>(`${BASE}/find-account`, { email }).then((r) => r.data);

// Danh sách tất cả tài khoản admin (chỉ Super Admin xem được).
export const listAdmins = () =>
  API.get<{ admins: AdminRow[]; assignableRoles: string[] }>(
    `${BASE}/list-admins`
  ).then((r) => r.data);

export const setAccountRoles = (email: string, roles: string[], totpCode: string) =>
  API.post<{ email: string; roles: string[] }>(`${BASE}/set-roles`, {
    email,
    roles,
    totpCode,
  }).then((r) => r.data);

// SuperAdmin reset Authenticator cho 1 tài khoản mất thiết bị (bắt mã Authenticator của chính SuperAdmin).
export const resetAuthenticator = (email: string, totpCode: string) =>
  API.post<{ email: string; reset: boolean }>(`${BASE}/reset-authenticator`, {
    email,
    totpCode,
  }).then((r) => r.data);

// Nhãn tiếng Việt cho vai trò.
export const ROLE_LABEL: Record<string, string> = {
  Mod: 'Kiểm duyệt viên',
  Accountant: 'Kế toán',
  Monetization: 'Quản lý kiếm tiền',
  Admin: 'Admin',
  SuperAdmin: 'Super Admin',
  Viewer: 'Chỉ xem',
};
